/*
  Expando
 */

var Expando = (function ($) {
  var m = (function () {
    var name = 'Expando';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    $.fn.extend({
      // Return the closest ancestor that matches selector
      // until an ancestor that matches mask is found.
      closestUntil: function (selector, mask, result) {
        result = typeof result !== 'undefined' ? result : new jQuery();

        if ($(this).is(selector)) {
          result = this;
        }
        else {
          var $parent = this.parent();

          if ($parent.length && $parent.not(mask)) {
            $parent.closestUntil(selector, mask, result);
          }
        }

        return result;
      },
      // Return all elements that match selector
      // except elements that are childen of parents
      // that match mask.
      findUntil: function (selector, mask, result) {
        result = typeof result !== 'undefined' ? result : new jQuery();

        this.children().each(function () {
          var thisObject = $(this);

          if (thisObject.is(selector)) {
            result.push(this);
          }
          else {
            if (!thisObject.is(mask)) {
              thisObject.findUntil(selector, mask, result);
            }
          }
        });

        return result;
      }
    });

    var handlers = {
      getExpandos: function ($group) {
        return $group.findUntil('.js-expando', '.js-expando');
      },
      getTrigger: function ($element) {
        return $element.findUntil('.js-expando__trigger', '.js-expando');
      },
      getContent: function ($element) {
        return $element.findUntil('.js-expando__content', '.js-expando');
      },
      collapse: function ($element, animate) {
        var $trigger = handlers.getTrigger($element);
        var $content = handlers.getContent($element);
        var duration = $element.data('expando-duration');
        var minHeight = $element.data('expando-height');

        var $heightMarker = $content.find('.js-expando__height-marker');
        if ($heightMarker.length) {
          minHeight = $heightMarker.offset().top - $element.offset().top;
        }

        $element.removeClass('is-expanded');
        $trigger.attr('aria-expanded', 'false');

        if (animate) {
          $content.stop(true).animate({
            height: minHeight
          }, duration, function () {
            if (minHeight === 0) {
              $content.css('display', 'none');
              $element.addClass('is-hidden');
            }
          });
        }
        else {
          $content.css({
            height: minHeight
          });
          if (minHeight === 0) {
            $content.css('display', 'none');
            $element.addClass('is-hidden');
          }
        }

        if ($trigger.data('expando-collapse-text') && $trigger.data('expando-expand-text')) {
          $trigger.text($trigger.data('expando-expand-text'));
        }
      },
      disable: function ($element) {
        $element.data('expando-disabled', true);
        $element.addClass('disabled');
        handlers.expand($element);
      },
      disableAccordion: function ($element) {
        $element.data('expando-accordion-disabled', true);
        handlers.collapse($element);
      },
      enable: function ($element) {
        $element.data('expando-disabled', false);
        $element.removeClass('disabled');
        handlers.collapse($element);
      },
      enableAccordion: function ($element) {
        $element.data('expando-accordion-disabled', false);
        handlers.collapse($element);
      },
      expand: function ($element, animate) {
        var $trigger = handlers.getTrigger($element);
        var $content = handlers.getContent($element);
        var duration = $element.data('expando-duration');

        $element.addClass('is-expanded');
        $trigger.attr('aria-expanded', 'true');

        if (animate) {
          $content.css('display', 'block');
          $content.stop(true).animate({
            height: $content[0].scrollHeight
          }, duration, function () {
            $content.css('height', '');
          });
        }
        else {
          $content.css('display', 'block');
          $content.css('height', '');
        }

        if ($trigger.data('expando-collapse-text') && $trigger.data('expando-expand-text')) {
          $trigger.text($trigger.data('expando-collapse-text'));
        }
      },
      init: function ($element) {
        $element.data('expando-disabled', false);
        $element.data('expando-accordion-disabled', false);

        if (!$element.data('expando-duration')) {
          $element.data('expando-duration', 400);
        }
        if (!$element.data('expando-height')) {
          $element.data('expando-height', 0);
        }

        handlers.collapse($element, false);
      },
      toggle: function ($element) {
        if ($element.hasClass('is-expanded')) {
          handlers.collapse($element, true);
        }
        else {
          handlers.expand($element, true);
        }
      },
      toggleClick: function ($trigger) {
        var $element = $trigger.closest('.js-expando');
        var expandoDisabled = $element.data('expando-disabled');
        var accordionDisabled = $element.data('expando-accordion-disabled');

        if (!expandoDisabled) {

          if (!accordionDisabled) {
            var $group = $element.parent().closestUntil('.js-expando__group', '.js-expando');

            if (!accordionDisabled && $group.length) {
              var $expandos = handlers.getExpandos($group);

              $expandos.each(function () {
                if (!$(this).is($element)) {
                  handlers.collapse($(this), true);
                }
              });
            }
          }

          handlers.toggle($element, true);
        }
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [
      'collapse',
      'disable',
      'disableAccordion',
      'enable',
      'enableAccordion',
      'expand',
      'init',
      'toggle',
      'toggleClick',
    ];

    /*
      Events
    */
    var events = {
      breakpoints: function () {
        $('.js-expando').each(function () {
          var $element = $(this);
          var accordionBreakpoint = $element.data('expando-accordion-breakpoint');
          var expandoBreakpoint = $element.data('expando-breakpoint');

          if (expandoBreakpoint) {
            enquire.register('screen and ' + expandoBreakpoint, {
              match: function () {
                handlers.disable($element);
              },
              unmatch: function () {
                handlers.enable($element);
              }
            });
          }

          if (accordionBreakpoint) {
            enquire.register('screen and ' + accordionBreakpoint, {
              match: function () {
                handlers.disableAccordion($element);
              },
              unmatch: function () {
                handlers.enableAccordion($element);
              }
            });
          }
        });
      },
      pageLoad: function () {
        $('.js-expando').each(function () {
          handlers.init($(this));
        });
      },
      triggerClick: function () {
        $('.js-expando__trigger').on('click', function (event) {
          event.preventDefault();
          var $trigger = $(this);
          handlers.toggleClick($trigger);
          $trigger.blur();
        });
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof(event) === 'function') {
            try {
              event();
            }
            catch(e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof(handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

    // Error-safe initialization
    $(function () {
      try {
        m._init_();
      }
      catch (e) {
        console.error('Module failed to initialize: ' + m);
        console.error(e);
      }
    });

    return m;
  }(jQuery));
